/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import CN from 'classnames'
import { useGetBulkStatusUpdateLogTable } from 'framework/api/methods'
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment'

import { Button } from 'components/atoms'
import { UploadOrderStatusUpdateFile } from 'components/DrawerModals/ManageOrders/UploadOrderStatusUpdateFile'

import { DataTable } from './ManageOrderStatusDataTable'

import 'react-toastify/dist/ReactToastify.css'

export interface ManageOrdersProps {
  [x: string]: any
}
export const ManageOrders: FC<ManageOrdersProps> = ({
  className,
}: ManageOrdersProps) => {
  const { userDetails }: any = useSelector<any>((state) => state.user)
  const manageOrdersModuleAccess = userDetails?.userPermissions?.includes(
    'PartnerOrdersBulkStatusUploadAccess',
  )
  const [rows, setRows] = useState({})
  const [totalRowCount, setTotalRowCount] = useState(0)
  const [uploadFileDrawerIsOpen, setUploadFileDrawerIsOpen] = useState(false)
  const [tableVariables, setTableVariables] = useState({
    take: 10,
    skip: 0,
    search: '',
  })

  const [pageNumber, setPageNumber] = useState(1)

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    }
  }
  /** API Call for get list using react-query */
  const {
    mutate: getGeBulkStatusUpdateLogListMutate,
    isLoading: getGeBulkStatusUpdateLogListIsLoading,
  } = useGetBulkStatusUpdateLogTable()
  /** Process the get invoice table data */
  async function getBulkStatusUpdateLogList(take?: number, skip?: number) {
    getGeBulkStatusUpdateLogListMutate(
      {
        take,
        skip,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          console.log(successData)
          setRows(successData?.partnerOrderBulkStatusUploadLogsList)
          setTotalRowCount(successData?.totalCount)
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...', 'error')
        },
      },
    )
  }

  /** call warehouses list when table variables change */
  useEffect(() => {
    getBulkStatusUpdateLogList(tableVariables.take, tableVariables.skip)
  }, [tableVariables])

  return (
    <div
      className={CN(
        'flex items-center justify-center bg-N-50 h-full w-full px-8 py-5',
        {},
        className,
      )}>
      <div className='flex flex-col h-full w-full rounded-lg bg-white shadow-md px-5 py-7 overflow-auto'>
        <div className='flex flex-col w-full h-full bg-white'>
          <h1 className='text-lg font-semibold'>Change Order Status</h1>
          <div className='flex w-full items-center justify-between pt-6'>
            <div className='flex gap-4'>
              <Button
                onClick={() => {
                  setUploadFileDrawerIsOpen(true)
                }}>
                <i className='ri-file-upload-line pr-2'></i>Upload File
              </Button>
              <Button
                onClick={() => {
                  const url =
                    'https://bdlmwdev.blob.core.windows.net/dev/BulkOrderStatusUpdateFiles/OrdersStatusUpdateTemplate.xlsx'
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute(
                    'download',
                    'OrdersStatusUpdateTemplate.xlsx',
                  )
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }}>
                <i className='ri-file-excel-2-line pr-2'></i> Download Template
              </Button>
            </div>
          </div>

          <div className='w-full h-[calc(100%-100px)] pt-4'>
            <DataTable
              itemData={rows}
              setTableVariables={setTableVariables}
              tableVariables={tableVariables}
              totalRowCount={totalRowCount}
              getGeBulkStatusUpdateLogListIsLoading={
                getGeBulkStatusUpdateLogListIsLoading
              }
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
            />
          </div>
          {uploadFileDrawerIsOpen && manageOrdersModuleAccess && (
            <UploadOrderStatusUpdateFile
              isActive={uploadFileDrawerIsOpen}
              onCloseClick={() => setUploadFileDrawerIsOpen(false)}
              notify={notify}
              getBulkStatusUpdateLogList={getBulkStatusUpdateLogList}
            />
          )}
          <ToastContainer
            position='top-right'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='colored'
            className='toast-container'
          />
        </div>
      </div>
    </div>
  )
}
ManageOrders.defaultProps = {}
export default ManageOrders
